import { combinationListSchema } from './comboRows.js';
import { elementListSchema } from './gemRows.js';
import {
  bannerResultSchema,
  bannerStoryboardResultSchema,
} from './ideation/banner/bannerResult.js';
import { ideationResultSchema } from './ideation/brief/briefResult.js';
import { elementPoolSchema, fillElementsSchema } from './ideation/elementPool.js';
import { storyboardResultSchema } from './ideation/storyboard/storyboardResult.js';
import { videoResultSchema } from './ideation/video/videoResult.js';
import { rowsOf } from './resultRows.js';
import { asRecord } from './resultValues.js';
import { risingElementsSchema } from './risingRows.js';

export type ParsedResult = ReturnType<typeof parseResult>;

export function parseResult(result: unknown, kind: string | null) {
  const resultType = asRecord(result)?.['result_type'];
  if (resultType === 'ideation_brief')
    return { kind: 'ideation_brief', parsed: ideationResultSchema.safeParse(result) } as const;
  // An element list whose rows rose against a previous window, not gems against the account.
  if (resultType === 'rising_elements')
    return { kind: 'rising_elements', parsed: risingElementsSchema.safeParse(result) } as const;
  if (resultType === 'fill_elements')
    return { kind: 'element_pool', parsed: fillElementsSchema.safeParse(result) } as const;
  if (kind === 'storyboard')
    return { kind, parsed: storyboardResultSchema.safeParse(result) } as const;
  if (kind === 'video') return { kind, parsed: videoResultSchema.safeParse(result) } as const;
  if (kind === 'banner_storyboard')
    return { kind, parsed: bannerStoryboardResultSchema.safeParse(result) } as const;
  if (kind === 'banner') return { kind, parsed: bannerResultSchema.safeParse(result) } as const;
  if (kind === 'element_pool')
    return { kind, parsed: elementPoolSchema.safeParse(result) } as const;
  if (kind === 'element_list')
    return { kind, parsed: elementListSchema.safeParse(result) } as const;
  if (kind === 'combination_list')
    return { kind, parsed: combinationListSchema.safeParse(result) } as const;
  return { kind: 'other', rows: rowsOf(result, kind) } as const;
}

// A run that saves more than one outcome opens on the one asked for: a Hidden Gems
// run's brief is its `briefs`, not its gems. Only an outcome besides the run's first is a facet.
export function parseOutcome(
  result: unknown,
  kind: string | null,
  outcomeKind: string | null,
  firstOutcomeKind: string | null,
) {
  return outcomeKind === 'brief' && outcomeKind !== firstOutcomeKind && kind !== 'brief'
    ? ({ kind: 'ideation_brief', parsed: ideationResultSchema.safeParse(result) } as const)
    : parseResult(result, kind);
}
